<template>
    <div v-click-outside="hideMenu"
         class="mobile-menu">
        <button :class="['mobile-menu__toggler', {'is-active': isOpen}]"
                @click="toggleMenu">
            <span class="line line1" />
            <span class="line line2" />
            <span class="line line3" />
        </button>

        <div :class="['mobile-menu__wrapper', { 'is-active': isOpen }]">
            <div class="mobile-menu__content">
                <div class="mobile-menu__actions">
                    <MobileMenuAction title="Проверить клиента"
                                      description="по базе ТЕКТА"
                                      icon="IconSearch"
                                      @click.native="_showUniqueCheckForm" />

                    <MobileMenuAction v-if="linksSettings?.presentationLink"
                                      title="Презентации проектов"
                                      description="Скачать презентации"
                                      icon="IconDownload"
                                      :link="linksSettings.presentationLink"
                                      is-external />

                    <MobileMenuAction v-if="linksSettings?.regulationsLink"
                                      title="Регламенты"
                                      description="Регламенты взаимодействия и актуальные комиссии"
                                      icon="IconDownload"
                                      :link="linksSettings.regulationsLink"
                                      is-external />

                    <MobileMenuAction title="Запись на брокер-тур"
                                      description="Знакомство с проектом"
                                      icon="IconArrowRight"
                                      @click.native="_showRequestBrokerTourForm" />

                    <MobileMenuAction v-if="linksSettings?.telegramChannel"
                                      title="Телеграм-канал для брокеров"
                                      description="Новости и предложения"
                                      icon="IconTelegram"
                                      :link="linksSettings.telegramChannel"
                                      is-external />
                </div>

                <ul class="mobile-menu__list">
                    <template v-for="item in menuItems">
                        <li v-if="!item.hide"
                            :key="item.link"
                            class="mobile-menu__item"
                            @click="hideMenu">
                            <router-link :to="item.link"
                                         active-class="is-active"
                                         class="mobile-menu__item-link">
                                <component :is="item.icon"
                                           v-if="item.icon"
                                           :class-name="item.iconModify" />
                                {{ item.name }}
                            </router-link>
                        </li>
                    </template>
                </ul>
                <div class="mobile-menu__user">
                    {{ userName }}
                </div>
                <div class="mobile-menu__bottom">
                    <router-link
                        to="/report-problems"
                        class="mobile-menu__bottom-link mobile-menu__bottom-report">
                        <IconAlertOutlineWhite class-name="icon-fill" />
                        Сообщить о проблеме
                    </router-link>
                    <span @click="hideMenu">
                        <router-link to="/profile"
                                     active-class="is-active"
                                     class="mobile-menu__bottom-link">
                            <IconUser class-name="icon-stroke" />
                            Мой профиль
                        </router-link>
                    </span>
                    <a href="#"
                       class="mobile-menu__bottom-link mobile-menu__exit-link"
                       @click.prevent="logoutUser">
                        <IconExit class-name="icon-stroke" />
                        Выйти
                    </a>
                </div>
                <div class="mobile-menu__footer">
                    <div class="mobile-menu__footer-copy">
                        © ТЕКТА — {{ year }}
                    </div>
                    <div class="mobile-menu__footer-logo">
                        <Kelnik />
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div v-if="isOpen"
                 class="mobile-menu__overlay" />
        </transition>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import IconAlertOutlineWhite from '@/components/Icons/AlertOutlineWhite';
import IconCompare from '@/components/Icons/Compare';
import IconDocumentSmall from '@/components/Icons/DocumentSmall';
import IconExit from '@/components/Icons/Exit';
import IconFavourites from '@/components/Icons/Favourites';
import IconHome from '@/components/Icons/Home';
import IconList from '@/components/Icons/List';
import IconLock from '@/components/Icons/Lock';
import IconNews from '@/components/Icons/News';
import IconUser from '@/components/Icons/User';
import Kelnik from '@/components/Icons/Kelnik';
import MobileMenuAction from '@/sections/MobileMenu/MobileMenuAction';
import {mapActions, mapGetters} from 'vuex';
import {goOut} from '@/store/settings';

export default {
    name: 'MobileMenu',

    inject: [
        'showUniqueCheckForm',
        'showRequestBrokerTourForm'
    ],

    components: {
        IconAlertOutlineWhite,
        IconCompare,
        IconDocumentSmall,
        IconExit,
        IconFavourites,
        IconHome,
        IconList,
        IconLock,
        IconNews,
        IconUser,
        Kelnik,
        MobileMenuAction
    },

    directives: {
        ClickOutside
    },

    props: {
        menuItems: Array
    },

    data() {
        return {
            isOpen: false,
            year  : new Date().getFullYear()
        };
    },

    computed: {
        ...mapGetters({
            userName       : 'GET_USER_NAME',
            token          : 'GET_TOKEN',
            linksSettings  : 'GET_LINKS_SETTINGS',
            isAuthenticated: 'GET_IS_AUTHENTICATED'
        }),
    },

    watch: {
        isOpen(value) {
            this.$emit('changeMobileMenu', value);
        }
    },

    async created() {
        if (Object.keys(this.linksSettings).length === 0 && this.isAuthenticated) {
            await this.getLinksSettings();
        }
    },

    methods: {
        ...mapActions(['getLinksSettings']),

        toggleMenu() {
            this.isOpen = !this.isOpen;
        },

        hideMenu() {
            if (!this.isOpen) {
                return;
            }

            this.isOpen = false;
        },

        _showUniqueCheckForm() {
            this.hideMenu();
            this.showUniqueCheckForm();
        },

        _showRequestBrokerTourForm() {
            this.hideMenu();
            this.showRequestBrokerTourForm();
        },

        /**
         * Выйти из аккаунта
         */
        logoutUser() {
            this.hideMenu();
            goOut();
        },
    }
};
</script>

<style lang="scss">
@import "MobileMenu";
</style>
